export const enum ButtonVariants {
  Primary = "primary",
  Secondary = "secondary",
  Warning = "warning",
  Disabled = "disabled",
  Outlined = "outlined",
  Danger = "danger",
}
